import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

const StudentAcademicSummaryQuery = graphql.persisted(
  "StudentAcademicSummary",
  graphql(`query StudentAcademicSummary($schoolId: ID!, $schoolYearId: ID!, $personId: ID!) {
    studentAcademicSummary(schoolId: $schoolId, schoolYearId: $schoolYearId, personId: $personId) {
      person { id firstName lastName }
      classGrades {
        transcriptName
        creditValue
        classOffering { id displayName }
        assignments {
          assignmentId
          name
          dueOn
          pointsPossible
          pointsEarned
          state
          percentage
          gradeColor
        }
        result {
          percentage
          letterGrade
          gradeColor
          earnedPoints
          possiblePoints
          includedAssignmentCount
          ungradedAssignmentCount
        }
      }
      missingAssignmentCount
      missingAssignments {
        assignmentId
        name
        className
        dueOn
        pointsPossible
      }
      attendance {
        presentCount
        absentCount
        tardyCount
        excusedCount
        recordedCount
        attendanceRate
        days {
          date
          status
          blockTitle
          scheduleBlockId
        }
      }
    }
  }`)
);

export { StudentAcademicSummaryQuery };

export function useStudentAcademicSummary(schoolId?: string, schoolYearId?: string, personId?: string) {
  return useQuery(StudentAcademicSummaryQuery, {
    variables: { schoolId: schoolId!, schoolYearId: schoolYearId!, personId: personId! },
    skip: !schoolId || !schoolYearId || !personId,
  });
}
